'use strict';

var _ = require('lodash');
var DuplicateWebFaresFinder = function DuplicateWebFaresFinder() {
  function countDuplicateObjects(original) {
    var compressed = [];
    var copy = original.slice(0);
    for (var originalIndex = 0; originalIndex < original.length; originalIndex++) {
      if (original[originalIndex].fareSource) {
        var myCount = 0;
        for (var copyIndex = 0; copyIndex < copy.length; copyIndex++) {
          if (_.isEqual(pickBySelectiveKey(original[originalIndex]), pickBySelectiveKey(copy[copyIndex]))) {
            myCount++;
            delete copy[copyIndex];
          }
        }
        if (myCount > 0) {
          var statistics = {};
          statistics.value = original[originalIndex];
          statistics.value.visible = false;
          statistics.count = myCount;
          compressed.push(statistics);
        }
      }
    }
    return compressed;
  }
  function pickBySelectiveKey(webFare) {
    return _.pick(webFare, ['carrier', 'market', 'tripType', 'compMarket', 'rbd', 'currencyCode', 'baseFare', 'totalFare', 'yq', 'yr', 'airportTax']);
  }
  function getDuplicateWebFares(original, selectedWebFare) {
    var duplicates = _.filter(original, pickBySelectiveKey(selectedWebFare));
    duplicates = _.forEach(duplicates, function (webFare) {
      webFare.visible = true;
    });
    return duplicates;
  }
  return {
    countDuplicateObjects: countDuplicateObjects,
    getDuplicateWebFares: getDuplicateWebFares
  };
};
module.exports = DuplicateWebFaresFinder;